import { alpha } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function Table(theme) {
  return {
    MuiTable: {
      styleOverrides: {
        root: {
          borderCollapse: "separate",
          borderSpacing: "0 8px",
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          transition: "transform 0.16s ease, box-shadow 0.16s ease",
          "& td": {
            transition: "background-color 0.16s ease, border-color 0.16s ease",
          },
          "&:hover td": {
            backgroundColor: alpha(theme.palette.primary.main, 0.035),
          },
          '&.Mui-selected': {
            "& td": {
              backgroundColor: alpha(theme.palette.primary.main, 0.08),
            },
            '&:hover td': {
              backgroundColor: alpha(theme.palette.primary.main, 0.12),
            },
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottom: "none",
        },
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: "transparent",
          '&:first-of-type': {
            paddingLeft: theme.spacing(3),
            borderTopLeftRadius: 14,
            borderBottomLeftRadius: 14,
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(3),
            borderTopRightRadius: 14,
            borderBottomRightRadius: 14,
          },
        },
        stickyHeader: {
          backgroundColor: "transparent",
          backgroundImage: "none",
        },
        body: {
          paddingTop: theme.spacing(1.3),
          paddingBottom: theme.spacing(1.3),
          backgroundColor: alpha(theme.palette.background.paper, 0.92),
          borderTop: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
          borderBottom: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
          '&:first-of-type': {
            paddingLeft: theme.spacing(3),
            borderLeft: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
            borderTopLeftRadius: 16,
            borderBottomLeftRadius: 16,
          },
          '&:last-of-type': {
            paddingRight: theme.spacing(3),
            borderRight: `1px solid ${alpha(theme.palette.grey[500], 0.12)}`,
            borderTopRightRadius: 16,
            borderBottomRightRadius: 16,
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          borderTop: `solid 1px ${alpha(theme.palette.grey[500], 0.12)}`,
        },
        toolbar: {
          minHeight: 56,
          height: 56,
          paddingLeft: theme.spacing(1),
          paddingRight: theme.spacing(1),
        },
        select: {
          '&:focus': {
            borderRadius: theme.shape.borderRadius,
          },
        },
        selectIcon: {
          width: 20,
          height: 20,
          marginTop: -4,
        },
        actions: {
          marginLeft: theme.spacing(1),
        },
      },
    },
  };
}
